/* import __COLOCATED_TEMPLATE__ from './single-select.hbs.js'; */
import { computed } from "@ember/object";
import { isEmpty } from "@ember/utils";
import { classNames } from "@ember-decorators/component";
import SelectKitComponent, { pluginApiIdentifiers, selectKitOptions } from "select-kit/components/select-kit";
const SingleSelect = dt7948.c(class SingleSelect extends SelectKitComponent {
  singleSelect = true;
  get selectedContent() {
    if (!isEmpty(this.value)) {
      let content;
      const value = this.selectKit.options.castInteger && this._isNumeric(this.value) ? Number(this.value) : this.value;
      if (this.selectKit.valueProperty) {
        content = (this.content || []).findBy(this.selectKit.valueProperty, value);
        return this.selectKit.modifySelection(content || this.defaultItem(value, value));
      } else {
        return this.selectKit.modifySelection((this.content || []).filter(c => c === value));
      }
    } else {
      return this.selectKit.noneItem;
    }
  }
  static {
    dt7948.n(this.prototype, "selectedContent", [computed("value", "content.[]", "selectKit.noneItem")]);
  }
}, [pluginApiIdentifiers(["single-select"]), selectKitOptions({
  headerComponent: "select-kit/single-select-header"
}), classNames("single-select")]);
export default SingleSelect;